module.exports = __webpack_public_path__ + "ba083c977b4b674f5f63643a2d0a85e0.svg";